// Global components.
import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

// Redux.
import { connect } from "react-redux";
import { getHomePage } from '../../actions/pageContentActions';

// Styles.
import '../../styles/pages/home/Home.scss';

class Home extends Component {
  componentDidMount() {
    this.props.getHomePage();
  }

  render() {
    const { homePage } = this.props;

    return (
      <Container className="mt-5">
        { typeof homePage[0] !== 'undefined' &&
          ReactHtmlParser(homePage[0].body[0].value)
        }
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    homePage: state.pageContents.homePage
  };
}

export default connect(mapStateToProps, { getHomePage })(Home);
